<template>
  <BuiEntityListingPage
    v-bind="listNamesConfig"
    :ItemsLister="MediaLister"
    :itemsListerBind="{ buiColumns: mediaColumns }"
  >
    <template #title-after v-if="user.hasCreateAccessToArea('MediaLibrary')">
      <UploadMediaButtonWithDialog
        v-if="
          user.hasCreateAccessToAssetType('Image') ||
          user.hasCreateAccessToAssetType('Video')
        "
      />
      <CreateSlideButtonWithDialog
        v-if="user.hasCreateAccessToAssetType('Slide')"
      />
    </template>
  </BuiEntityListingPage>
</template>

<script lang="ts" setup>
import MediaLister from './MediaLister/MediaLister.vue';
import listNamesConfig from "./MediaLister/config/listNames.config";
import mediaColumns from "./MediaLister/config/tableColumns.config";
import BuiEntityListingPage from '@/components/bui/organisms/EntityListingPage';
import UploadMediaButtonWithDialog from './TopBarMainButtons/UploadMedia/UploadMediaButtonWithDialog.vue';
import CreateSlideButtonWithDialog from './TopBarMainButtons/CreateSlide/CreateSlideButtonWithDialog.vue';
import useUser from '@/composables/user';

const user = useUser();
</script>

<style lang="scss" scoped>
</style>
